<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("add") }} {{ $t("bank") }}</div>
      <div>
        <router-link class="btn-blue" to="bank"
          >{{ $t("bank") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="bankDetails.bank_name"
                v-validate="{ required: 'required', regex: /^[a-zA-Z ]*$/ }"
                name="bank_name"
                id="bank_name"
              />
              <label>{{ $t("bank") }} {{ $t("name") }}</label>
            </div>
            <!-- <Tooltip :title="$t('enterBankName')"  /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('bank_name')">{{
              errors.first("bank_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="bankDetails.bank_address"
                name="bank_address"
                id="bank_address"
              />
              <label>{{ $t("address") }}</label>
            </div>
            <!-- <Tooltip :title="$t('enterBankAddress')"  /> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.Country && selected.Country.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $tc("country", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.Country" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(country, countryIndex) in Countries"
                  :key="countryIndex"
                  v-on:click="onSelectHandler('country',country)"
                  name="selectcountry"
                  id="selectcountry"
                >{{ country.country_name }}</b-dropdown-item>
              </b-dropdown> -->
              <multiselect
                :options="Countries"
                v-model="selected_country"
                :searchable="true"
                label="country_name"
                track-by="country_name"
                placeholder="."
                @input="onSelectHandler('country', $event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <!-- <Tooltip :title="$t('selectTheBankResides')"  /> -->
            </div>
            <p class="error_message">
              <span>{{ msgcinema }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.State && selected.State.length > 0 ? 'shift-up' : ''
              "
              >{{ $t("select") }} {{ $tc("state", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.State" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(state, stateIndex) in States"
                  :key="stateIndex"
                  @click="onSelectHandler('state',state)"
                  name="selectstate"
                  id="selectstate"
                >{{ state.state_name }}</b-dropdown-item>
              </b-dropdown> -->
              <multiselect
                :options="States"
                v-model="selected_state"
                :searchable="true"
                label="state_name"
                track-by="state_name"
                placeholder="."
                :allowEmpty="false"
                :showLabels="false"
                @input="onSelectHandler('state', $event)"
              ></multiselect>
              <!-- <Tooltip :title="$tc(`select_TheBankResides`)"  /> -->
            </div>
            <p class="error_message">
              <span>{{ msgcinema }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.City && selected.City.length > 0 ? 'shift-up' : ''
              "
              >{{ $t("select") }} {{ $tc("city", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.City" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(city,cityIndex) in Cities"
                  :key="cityIndex"
                  @click="onSelectHandler('city',city)"
                  name="selectcity"
                  id="selectcity"
                >{{ city.city_name }}</b-dropdown-item>
              </b-dropdown> -->
              <multiselect
                :options="Cities"
                v-model="selected_city"
                :searchable="true"
                label="city_name"
                track-by="city_name"
                placeholder="."
                :allowEmpty="false"
                :showLabels="false"
                @input="onSelectHandler('city', $event)"
              ></multiselect>
              <!-- <Tooltip :title="$tc(`selectCityTheBankResides`)"  /> -->
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  v-model="bankDetails.bank_is_active"
                  unchecked-value="N"
                  value="Y"
                  switch
                  class="j-checkbox"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label for="file-selector" class="file-selector w-100">
              <label
                class="file-selector-label"
                :class="
                  bankDetails.bank_logo_url &&
                  bankDetails.bank_logo_url.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("uploadbanklogo") }}</label
              >
              <span>{{ bankDetails.bank_logo_url }}</span>
              <input
                v-on:change="uploadImage($event)"
                type="file"
                class="d-none"
                id="file-selector"
              />
            </label>

            <!-- <Tooltip :title="$tc('LogoShouldbeOfDimension')" /> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
            to="/marketing/bank"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="bank">{{
            $t("cancel")
          }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";
export default {
  data() {
    return {
      selected_country: null,
      selected_state: null,
      selected_city: null,
      btenable: false,
      selected: {
        Country: "",
        State: "",
        City: "",
      },
      msgcinema: "",
      loginRoleId: null,
      messagebankname: "Please Enter Name.",
      messageaddress: "Please Enter Address.",
      messagestate: "Please Select State.",
      messagecity: "Please Select City.",
      messagecountry: "Please Select Country.",

      submitted: false,
      isRoleID: true,
      bankDetails: {
        bank_logo_url: null,
        bank_id: null,
        bank_name: null,
        bank_address: null,
        city_id: null,
        state_id: null,
        country_id: null,
        city_name: null,
        country_name: null,
        state_name: null,
        bank_is_active: "N",
      },

      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities",
      },
      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states",
      },
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },
    };
  },
  beforeMount() {
    this.getCountriesList();
    // this.getStatesList();
    // this.getCitiesList();
  },
  mounted() {
    // const { bank_id } = this.$route;
  },
  methods: {
    onResetForm: function () {
      this.bankDetails = {
        bank_logo_url: null,
        bank_is_active: "N",
        bank_id: null,
        bank_name: null,
        bank_address: null,
        city_id: null,
        state_id: null,
        country_id: null,
      };
      this.selected = {
        City: "",
        Country: "",
        State: "",
      };
    },
    uploadImage: function (image) {
      // console.log("imagee",image);
      let self = this;
      let formData = new FormData();
      formData.append("image", image.target.files[0]);
      formData.append("imagePath", "Bank Image");
      MasterService.GlobalUploadImage(formData)
        .then((response) => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.bankDetails.bank_logo_url = data.path;
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(this._CatchError);
    },
    getCountriesList: function () {
      this.Countries = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getStatesList: function (cid) {
      let payload = {
        tableName: "ms_states",
        state_is_active: "Y",
        country_id: cid,
      };
      MasterService.GetActiveList(payload)
        // this.States = [];
        // let body = this.getRequestBody("GET", undefined, {
        //   ...this.StatesMethod,
        //   params: { id: "country_id-" + country_id }
        // });
        // MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.States = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCitiesList: function (s_id) {
      this.Cities = [];
      let payload = {
        tableName: "ms_cities",
        city_is_active: "Y",
        state_id: s_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.Cities = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectHandler: function (type, value) {
      if (type == "country") {
        // console.log("value :", value);
        this.selected.country_id = value.country_id;
        this.selected.Country = value.country_name;
        this.bankDetails.country_id = value.country_id;
        this.selected.State = "";
        this.bankDetails.state_id = null;
        this.selected.City = "";
        this.bankDetails.city_id = null;
        this.Cities = [];
        this.selected_state = null;
        this.selected_city = null;
        this.getStatesList(value.country_id);
      } else if (type == "state") {
        (this.selected.State = value.state_name),
          (this.bankDetails.state_id = value.state_id);
        this.selected.City = "";
        this.bankDetails.city_id = null;
        this.selected_city = null;
        this.getCitiesList(value.state_id);
      } else if (type == "city") {
        (this.selected.City = value.city_name),
          (this.bankDetails.city_id = value.city_id);
      }
    },
    // onReset: function () {
    //     this.bankDetails.bank_name=null,
    //     this.bankDetails.bank_address=null,
    //     this.bankDetails.city_id=null,
    //     this.bankDetails.state_id=null,
    //     this.bankDetails.country_id=null,
    //     this.selected.City=null,
    //     this.selected.Country=null,
    //     this.selected.State=null,
    //     this.bankDetails.bank_is_active="Y"
    // },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator
        .validate()
        .then((valid) => {
          if (valid) {
            this.btenable = true;
            MarketingService.addBank({ ...this.bankDetails }).then(
              (response) => {
                this.btenable = false;
                const { data } = response;
                if (data.status) {
                  this.onResetForm();
                  this.$toasted.show(data.message);
                  if (redirect) {
                    // console.log("redirect value ", redirect);
                    this.$router.push({
                      path: "/marketing/bank",
                    });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              }
            );
          }
        })
        .catch(this._CatchError);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/bankComponents/addBank.vue